module.exports = __webpack_public_path__ + "static/media/icon-windcreek-inverse.1afc9e76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingIndicator/icon-windcreek-inverse.svg
// module id = 1127
// module chunks = 1